(function ($) {
  $(document).ready(function () {
    if ($('.js-quantity').length) {
      // We are preventing duplicated binding with calling .off() first
      $(document).on('click', '.js-quantity-up', function () {
        const inst = $(this),
          input = inst.parent().find('.js-quantity-input'),
          step = input.attr('step') || 1,
          max = input.attr('max'),
          oldValue = parseFloat(input.val());
        let newVal;

        if (max !== '' && oldValue >= max) {
          newVal = oldValue;
        } else {
          newVal = oldValue + parseFloat(step);
        }

        input.val(newVal);
        input.trigger('change');
        input.trigger('keypress');

        input.trigger('custom_change', 'up');
      });

      $(document).on('click', '.js-quantity-down', function () {
        const inst = $(this),
          input = inst.parent().find('.js-quantity-input'),
          step = input.attr('step') || 1,
          min = input.attr('min'),
          oldValue = parseFloat(input.val());
        let newVal;

        if (oldValue <= min) {
          newVal = oldValue;
        } else {
          newVal = oldValue - parseFloat(step);
        }

        input.val(newVal);
        input.trigger('change');
        input.trigger('keypress');

        input.trigger('custom_change', 'down');
      });

      // Auto update cart
      let timeout;
      $(document).on('change', '.js-quantity-input', function () {
        // Do not update if is cross sell product input
        if ($(this).hasClass('js-no-update')) {
          return;
        }

        if (timeout !== undefined) {
          clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
          $('.js-update-cart').removeAttr('disabled').trigger('click');
        }, 1000);
      });
    }
  });
})(jQuery);
